module.exports = __webpack_public_path__ + "img/mantatech-logo.4a315eb4.png";